import { Component, Injectable } from "@angular/core"
import { AdalService } from "../../shared/adal.service";
import { ActivatedRoute, Route, Router } from "@angular/router";
import { NotificationService } from "../../services/NotificationService";
import { MdSnackBar } from "@angular/material";
import { AppLoaderService } from "../../../services/app-loader/app-loader.service";
import moment from "moment";
import { ProductService } from "../../services/ProductService";
import { IPushNotificationDropDownItem, IPushNotificationHistoryDisplay, ProductsWithPushNotification } from "../../interfaces/PushNotificationHistory";

@Component({
  selector: 'my-app-push-notification',
  template: require('./push-notification-history.component.html')
})
@Injectable()
export class PageLayoutPushNotificationHistoryComponent {
  public inputTitle: string;
  public inputBody: string;
  public errorMessage: string="";
  public pager: any = {};
  public pagedItems: any[];
  public userrightssummary: any;
  public selected: IPushNotificationDropDownItem
  public productId: number;
  public productName: string;
  public productCode: number = 12;
  public productVariant: number = 0;
  public pushNotificationHistoryList: Array<IPushNotificationHistoryDisplay> = []
  public productData: any = []
  public items: Array<IPushNotificationDropDownItem> = []
  public IsProductSubTypeVisible: boolean = true;

  constructor(
    private router: Router,
    private route:ActivatedRoute,
    private adalService: AdalService,
    private notificationService: NotificationService,
    private appLoaderService: AppLoaderService,
    private productService: ProductService,
    public snackBar: MdSnackBar,

  ) {
    //Check Authentication
    if (!this.adalService.getCachedToken()) {
      this.router.navigate(["login"]);
    }
    this.appLoaderService.open();
    this.route.params.subscribe((params)=>{
      this.productId=params["id"]
      this.productName=params["Title"];
    })
    this.getPushNotificationHistoryByProductId(this.productId)
  }
  getPushNotificationHistoryByProductId(productId: number) {
    this.notificationService.getNotificationHistoryByProductId(productId).subscribe((data) => {
      if (!data.IsError && data.DataObject != null && data.DataObject.length > 0) {
        if(data.DataObject[0].ProductSubType==null){
          this.IsProductSubTypeVisible=false;
        }
        else{
          this.IsProductSubTypeVisible=true;
        }
        this.pushNotificationHistoryList = data.DataObject;
        this.appLoaderService.close()
      }
      else if(!data.IsError && data.DataObject != null && data.DataObject.length == 0) {
        this.errorMessage="No Records Found";
        this.pushNotificationHistoryList = [];
        this.appLoaderService.close()
      }
      else{
        this.errorMessage=data.IsError;
        this.pushNotificationHistoryList = [];
        this.appLoaderService.close()
      }
    })
  }
  UTCToLocalTimeZone(date) {
    let stillUtc = moment.utc(date).toDate();
    let theDate = moment(stillUtc).local();
    return theDate.toLocaleString();
  }
  selectChange() {
    this.appLoaderService.open()
    this.getPushNotificationHistoryByProductId(this.selected.ProductId)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/page-layouts/push-notification/push-notification-history.component.ts